import api from '@shared/api/apiConfig';
import {
  getAllActivePublishersURI,
  getAppsBySpIdURI,
} from '@shared/api/endpoints';

export interface IActiveAppResponse {
  appId: string
  appName: string
  appBundle: string
  pubId: string
  appDomain: string
  appStoreUrl: string
  appCat: string
  appPrivacyPolicy: number
  appIdDp1: string
  isActive: number
  siteIdMagnite: number
  appContext: number
  appIdPubmatic: string
  platform: string
  defaultTmaxBanner: number
  defaultTmaxNative: number
  defaultTmaxInterstitial: number
  defaultTmaxRewarded: number
  defaultTmaxVideo: number
  precedenceDefaultTmaxBanner: boolean
  precedenceDefaultTmaxNative: boolean
  precedenceDefaultTmaxInterstitial: boolean
  precedenceDefaultTmaxRewarded: boolean
  precedenceDefaultTmaxVideo: boolean
  defaultBidFloorBanner: number
  defaultBidFloorNative: number
  defaultBidFloorInterstitial: number
  defaultBidFloorRewarded: number
  defaultBidFloorVideo: number
  precedenceDefaultBidFloorBanner: boolean
  precedenceDefaultBidFloorNative: boolean
  precedenceDefaultBidFloorInterstitial: boolean
  precedenceDefaultBidFloorRewarded: boolean
  precedenceDefaultBidFloorVideo: boolean
  numberDPBanner: number
  numberDPNative: number
  numberDPRewarded: number
  numberDPInterstitial: number
  numberDPVideo: number
  rateLimitConfig: RateLimitConfig
  inmobiFlag: boolean
  magniteFlag: boolean
  pubmaticFlag: boolean
}
export interface RateLimitConfig {
  "VIDEO-ALL": number
  "BANNER-ALL": number
  "NATIVE-ALL": number
  "REWARDED-ALL": number
  "INTERSTITIAL-ALL": number
}

export interface IActiveDPResponse {
  dpId: string
  dpAlias: string
  dpIdentifier: string
  rtbVersion: string
  paymentMethod: string
  logsRetention: number
  demandPartnerType: string
  jsonSupported: number
  displayManager: string
  displayManagerVer: string
  countryList: string
  supportedAdFormats: string
  appsAllowList: string
  isActive: number
  allAppsList: string
}

export interface IActivePublisherResponse {
  pubId: string
  pubName: string
}


export async function fetchActiveApps(): Promise<IActiveAppResponse[]> {
  // TODO: Update the endpoint to the new one once it's ready(getAllActiveAppsURI). The current endpoint is a temporary solution and should be replaced.
  const response = await api.get<IActiveAppResponse[]>('https://internal.ctech.works/inventory-management/getAllActiveApps', {
    headers: { 'X-Encrypted': 'true' }
  });
  return response;
}

export async function fetchActiveAppsBySpId(spId: string): Promise<IActiveAppResponse[]> {
  const response = await api.get<IActiveAppResponse[]>(getAppsBySpIdURI(spId));
  return response;
}

export async function fetchActiveDemandPartners(): Promise<IActiveDPResponse[]> {
  // TODO: Update the endpoint to the new one once it's ready(getAllActiveDemandPartnersURI). The current endpoint is a temporary solution and should be replaced.
  const response = await api.get<IActiveDPResponse[]>(`https://internal.ctech.works/partner/getAllDemandPartners?isActive=2`);
  return response
}

export async function fetchActivePublishers(): Promise<IActivePublisherResponse[]> {
  const response = await api.get<IActivePublisherResponse[]>(getAllActivePublishersURI, {
    headers: { 'X-Encrypted': 'true' }
  });
  return response;
}
